

import { requestDetailState } from '../requestDetail/states/requestDetailState';
import { requestDetailEditState } from '../requestDetailEdit/states/requestDetailEditState';
import { UserInfoService } from '../../userInfo/services/UserInfoService';

export class RequestsController implements ng.IController {

    static $inject = ['$http', '$scope', '$mdMedia', '$state', 'UserInfoService'];
    

    constructor(private _$http: angular.IHttpService, private _$scope: angular.IScope,
        private _$mdMedia: angular.material.IMedia,
        private _$state: angular.ui.IStateService,
        private _userInfoService: UserInfoService ) {
    }

    $onInit() { }

    get hideToolbar(): boolean {
        let shouldHide = false;
        

        if (this._$mdMedia('xs') || this._$mdMedia('sm')) {
                shouldHide = true;
        }

        
        return shouldHide;
    }

    get showDetail(): boolean {
       

        return !this.hideToolbar || (this._userInfoService.getUserInfo().role.indexOf("receiver") >= 0 ? this._$state.is(requestDetailEditState.name) : this._$state.is(requestDetailState.name)) ;

    }

    

}

angular.module('deliveryCreate.app').controller('RequestsController', RequestsController);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requests/requestsController.ts
 **/